//Importación de librerias
//---------------SIAP---------------
//Catalogos
import C025TiposNivelAcademico from '../../../src/components/SIAP/Comun/Catalogos/025TiposNivelAcademico.vue'
import C002TipoTitulo         from '../../../src/components/SIAP/Comun/Catalogos/002TiposTitulo.vue'
import C024TipoDocumento from '../../../src/components/SIAP/Comun/Catalogos/024TipoDocumento.vue'
import C022TipoMovimiento from '../../../src/components/SIAP/Comun/Catalogos/022TiposMovimiento.vue'
import C003TipoTurno from '../../../src/components/SIAP/Comun/Catalogos/003TiposTurno.vue'
import C028TipoPlaza from '../../../src/components/SIAP/Comun/Catalogos/028TiposPlaza.vue'
import ModalCapturaFecha from '../../../src/components/SIAP/Comun/Modales/ModalCapturaFecha.vue'
import C008TipoParentesco from '../../../src/components/SIAP/Comun/Catalogos/008TiposParentesco.vue'
import C027TipoContrato from '../../../src/components/SIAP/Comun/Catalogos/027TiposContrato.vue'
import ModalCapturaFecha from '../../../src/components/SIAP/Comun/Modales/ModalCapturaFecha.vue'
import ModalRedirigeUsuario from '../../../src/components/SIAP/Comun/Modales/ModalRedirigeUsuario.vue'
import ModalConfirmacion from '../../../src/components/SIAP/Comun/Modales/ModalConfirmacion.vue'
import RostroDePersona  from "../../../src/components/SIAP/Comun/RostroDePersona.vue";
import FirmaAutografa from "../../../src/components/SIAP/FirmaAutografa/FirmaAutografa.vue";
import C032TipoEstatusIncidencias from '../../../src/components/SIAP/Comun/Catalogos/032TipoEstatusIncidencia'
import C033TipoIncidencias from '../../../src/components/SIAP/Comun/Catalogos/033TipoIncidencias.vue'
import C034TipoSubIncidencias from '../../../src/components/SIAP/Comun/Catalogos/034SubTipoIncidencias.vue'
import C037TiposPlantillasDeNombramientos from '../../../src/components/SIAP/Comun/Catalogos/037TiposPlantillasDeNombramientos.vue'
import C043TiposAsunto from '../../../src/components/SIAP/Comun/Catalogos/043TiposAsunto.vue'

//Creamos y asignamos los datos necesarios de SIAP
const siap = [
  { Proviene: 'SIAP', Nombre: 'C025TiposNivelAcademico', datos: C025TiposNivelAcademico },
  { Proviene: 'SIAP', Nombre: 'C002TipoTitulo', datos: C002TipoTitulo },
  { Proviene: 'SIAP', Nombre: 'C024TipoDocumento', datos: C024TipoDocumento },
  { Proviene: 'SIAP', Nombre: 'C022TipoMovimiento', datos: C022TipoMovimiento },
  { Proviene: 'SIAP', Nombre: 'C003TipoTurno', datos: C003TipoTurno },  
  { Proviene: 'SIAP', Nombre: 'ModalCapturaFecha', datos: ModalCapturaFecha },
  { Proviene: 'SIAP', Nombre: 'C028TipoPlaza', datos: C028TipoPlaza },
  { Proviene: 'SIAP', Nombre: 'C008TipoParentesco', datos: C008TipoParentesco },
  { Proviene: 'SIAP', Nombre: 'C027TipoContrato', datos: C027TipoContrato },
  { Proviene: 'SIAP', Nombre: 'ModalCapturaFecha', datos: ModalCapturaFecha },
  { Proviene: 'SIAP', Nombre: 'ModalRedirigeUsuario', datos: ModalRedirigeUsuario },
  { Proviene: 'SIAP', Nombre: 'ModalConfirmacion', datos: ModalConfirmacion },
  { Proviene: 'SIAP', Nombre: 'RostroDePersona' , datos: RostroDePersona },
  { Proviene: 'SIAP', Nombre: 'FirmaAutografa', datos: FirmaAutografa },
  { Proviene: 'SIAP', Nombre: 'C032TipoEstatusIncidencias', datos: C032TipoEstatusIncidencias},
  { Proviene: 'SIAP', Nombre: 'C033TipoIncidencias', datos: C033TipoIncidencias},
  { Proviene: 'SIAP', Nombre: 'C034TipoSubIncidencias', datos: C034TipoSubIncidencias},
  { Proviene: 'SIAP', Nombre: 'C037TiposPlantillasDeNombramientos', datos: C037TiposPlantillasDeNombramientos },
  { Proviene: 'SIAP', Nombre: 'C043TiposAsunto', datos: C043TiposAsunto }
]

//Exportamos los datos de SIAP
export default siap;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/siap.js
// module id = null
// module chunks = 